/**
 * Poseedores API
 * Poseedores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GestoresResiduosModel } from './gestoresResiduosModel';
import { AdheridoReferenceModel } from './adheridoReferenceModel';
import { DocumentoModel } from './documentoModel';
import { FacturaEstadoModel } from './facturaEstadoModel';
import { GestorPtoRecogidaReferenceModel } from './gestorPtoRecogidaReferenceModel';
import { PoseedorReferenceModel } from './poseedorReferenceModel';


export interface FacturaModel { 
    fechaAlta?: string;
    creadoPor?: string;
    fechaModificacion?: string;
    modificadoPor?: string;
    deleted?: string;
    deletedBy?: string;
    id?: number;
    poseedor?: PoseedorReferenceModel;
    gestorPtoRecogida?: GestorPtoRecogidaReferenceModel;
    gestoresResiduos?: GestoresResiduosModel;
    origen?: FacturaModel.OrigenEnum;
    numeroFactura?: string;
    estado?: FacturaEstadoModel;
    documento?: DocumentoModel;
    documentoAutofactura?: DocumentoModel;
    fechaAutofactura?: string;
    fechaFactura?: string;
    adherido?: AdheridoReferenceModel;
    esSolicitudSDDRCA?: boolean;
    registrada?: boolean;
    anioAportaciones?: number;
    kilosTotales?: string;
    importeTotal?: string;
    numeroFacturaUipath?: string;
    fechaFacturaUipath?: string;
    cifPoseedorUipath?: string;
    baseImponibleUipath?: number;
    tipoIVAUipath?: number;
    importeIVAUipath?: number;
    totalFacturaUipath?: number;
    ibanUipath?: string;
    swiftUipath?: string;
    motivoRechazo?: string;
    facturacionRecordada?: boolean;
}
export namespace FacturaModel {
    export type OrigenEnum = 'POSEEDORES' | 'PUNTOSRECOGIDA' | 'SDDRCC' | 'SDDRCA' | 'ADHERIDO' | 'GESTORESACUERDO';
    export const OrigenEnum = {
        Poseedores: 'POSEEDORES' as OrigenEnum,
        Puntosrecogida: 'PUNTOSRECOGIDA' as OrigenEnum,
        Sddrcc: 'SDDRCC' as OrigenEnum,
        Sddrca: 'SDDRCA' as OrigenEnum,
        Adherido: 'ADHERIDO' as OrigenEnum,
        Gestoresacuerdo: 'GESTORESACUERDO' as OrigenEnum
    };
}


